import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import {AutoTranslate} from "@/lib/autoTranslate.tsx"
import { useTranslation} from "react-i18next";
import { SEO } from "@/components/SEO";

const NotFound = () => {
  const location = useLocation();
  const transText = useTranslation().t('autoTranslate', { returnObjects: true });
  const { i18n } = useTranslation();



  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <main className="min-h-screen flex items-center justify-center bg-gray-100">
      <SEO
        title="Page Not Found — FIND Resume Builder"
        description="The page you're looking for doesn't exist. Return to FIND Resume Builder to keep building your AI-powered resume."
        path={location.pathname}
      />
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-4">404</h1>
        <p className="text-xl text-gray-600 mb-4">{AutoTranslate(`Oops! Page not found`)}</p>
        <a href="/" className="text-blue-500 hover:text-blue-700 underline">
          {AutoTranslate(`Return to Home`)}
        </a>
      </div>
    </main>
  );
};

export default NotFound;